import React, { useState, useEffect } from 'react';
import { CModal, CModalHeader, CModalBody, CModalTitle } from '@coreui/react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { FaPodcast } from "react-icons/fa";
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import { CountrySelect, StateSelect, CitySelect } from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import modal from '../../assets/images/modal.png';
import api from '../../service/caller';

const EditLocation = ({ closeModal }) => {

    const location = useLocation();
    const navigate = useNavigate();
    const hospitalId = location.state?.hospitalId;

    const [showaddressModal, setShowAddressModal] = useState(false);
    const [visible, setVisible] = useState(true);
    const [clinicName, setClinicName] = useState('');
    const [clinicAddress, setClinicAddress] = useState('');
    const [country, setCountry] = useState(null);
    const [currentState, setCurrentState] = useState(null);
    const [currentCity, setCurrentCity] = useState(null);
    const [telephone1, setTelephone1] = useState('');
    const [telephone2, setTelephone2] = useState('');
    const [currency, setCurrency] = useState('');
    const [errors, setErrors] = useState({});

    const handleClose = () => {
        setVisible(false);
        navigate('/hospitaladmin/locationSetting');
    };

    useEffect(() => {
        if (!hospitalId) {
            toast.error('Invalid hospital ID');
            return;
        }

        const fetchLocationData = async () => {
            try {
                const response = await api.get(`/api/gethospital/${hospitalId}`);
                const data = response.data;
                const address = `${data.hospital_country}, ${data.hospital_city}, ${data.hospital_state_province}`
                setClinicName(data.hospital_name);
                setClinicAddress(address);
                setCountry(data.hospital_country);
                setCurrentState(data.hospital_state_province);
                setCurrentCity(data.hospital_city);
                setTelephone1(data.hospital_phone);
                setTelephone2(data.hospital_phone2);
                setCurrency(data.hospital_currency);
            } catch (error) {
                toast.error('Failed to fetch location data');
            }
        };

        fetchLocationData();
    }, [hospitalId]);

    // Ouvrir et fermer le modal
    const handleInputClick = () => setShowAddressModal(true);
    const handleCloseInputModal = () => setShowAddressModal(false);

    const handleSaveAddress = () => {
        const address = `${country?.name}, ${currentCity?.name}, ${currentState?.name}`;
        setClinicAddress(address);
        handleCloseInputModal();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = {
            hospital_name: clinicName,
            hospital_country: country?.name,
            hospital_city: currentCity?.name,
            hospital_state_province: currentState?.name,
            hospital_phone: telephone1,
            hospital_phone2: telephone2,
            hospital_currency: currency,
        };

        try {
            const token = localStorage.getItem('access_token');
            if (!token) {
                throw new Error('Session expired. Please log in again.');
            }

            const response = await api.put(`/api/updatehospital/${hospitalId}`, formData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            toast.success('Location updated successfully!');
            setTimeout(() => {
                handleClose(); // ou navigate()
            }, 1500);
        } catch (error) {
            const errorMessage = error.response?.data?.error || error.message || 'An unknown error occurred.';
            toast.error(`Error: ${errorMessage}`);
        }
    };

    return (
        <>
        <ToastContainer />
        <CModal className='newregistermodal'
            alignment="center"
            scrollable
            size='lg'
            visible={visible}
            onClose={handleClose}
            aria-labelledby="VerticallyCenteredScrollableExample2">
            <CModalHeader>
                <CModalTitle>Edit Location</CModalTitle>
            </CModalHeader>
            <CModalBody>
                <div className="girla">
                    <div className="p-3 p-md-4 mt-3 mt-md-5 border rounded bg-light">
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                {/* <label >Enter clinic name</label> */}
                                <input
                                    type="text"
                                    name="clinicName"
                                    className="form-control"
                                    placeholder="Clinic name"
                                    value={clinicName}
                                    onChange={(e) => setClinicName(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-4 mb-md-5">
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Clinic's address"
                                        value={clinicAddress}
                                        onClick={handleInputClick}
                                        readOnly
                                    />
                                    {/* <span className="input-group-text">📍</span> */}
                                </div>
                            </div>
                            <div className="row mb-3 mt-2 phonefield">
                                <div className="col-12 col-md-6 mb-3 mb-md-0">
                                    <PhoneInput
                                        country="bj"
                                        value={telephone1}
                                        onChange={setTelephone1}
                                        inputClass="form-control"
                                        placeholder="Telephone 1"
                                        containerStyle={{ width: '100%' }}
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <PhoneInput
                                        country="bj"
                                        value={telephone2}
                                        onChange={setTelephone2}
                                        inputClass="form-control"
                                        placeholder="Telephone 2"
                                        containerStyle={{ width: '100%' }}
                                    />
                                </div>
                            </div>
                            <div className="form-floating mb-3 mt-2">
                                <select
                                    className="form-control"
                                    value={currency}
                                    onChange={(e) => setCurrency(e.target.value)}
                                >
                                    <option value="">Select Currency</option>
                                    <option value="USD">USD</option>
                                    <option value="EUR">EUR</option>
                                    <option value="GBP">GBP</option>
                                    <option value="XOF">XOF</option>
                                </select>
                                {/* <label htmlFor="currency">Currency</label> */}
                            </div>

                            <div className="text-center text-md-end mt-4">
                                <button className="btn btn-primary" type="submit">
                                    Save Changes
                                </button>
                            </div>
                        </form>

                        {/* Modal Bootstrap */}
                        <Modal show={showaddressModal} onHide={handleCloseInputModal} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Address <FaPodcast className="dill" /></Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {/* Pays */}
                                <div className="form-group w-100 custom-select-container mb-3">
                                    {/* Country Select */}
                                    <CountrySelect
                                        containerClassName="custom-select"
                                        onChange={(_country) => setCountry(_country)}
                                        placeHolder="Select Country"
                                    />
                                    {errors.country && <span className="error">{errors.country}</span>}
                                </div>

                                <div className="form-group w-100 custom-select-container mb-3">
                                    {/* State Select */}
                                    <StateSelect
                                        countryid={country?.id}
                                        containerClassName="custom-select"
                                        onChange={(_state) => setCurrentState(_state)}
                                        placeHolder="Select State"
                                    />
                                    {errors.currentState && <span className="error">{errors.currentState}</span>}
                                </div>

                                <div className="form-group w-100 custom-select-container mb-3">
                                    {/* City Select */}
                                    <CitySelect
                                        countryid={country?.id}
                                        containerClassName="custom-select"
                                        stateid={currentState?.id}
                                        onChange={(_city) => setCurrentCity(_city)}
                                        placeHolder="Select City"
                                    />
                                    {errors.currentCity && <span className="error">{errors.currentCity}</span>}
                                </div>
                            </Modal.Body>
                            <Modal.Footer className="justify-content-center justify-content-md-end">
                                <Button
                                    variant="primary"
                                    onClick={handleSaveAddress}
                                    disabled={!country || !currentCity || !currentState}
                                >
                                    Save changes
                                </Button>
                            </Modal.Footer>
                        </Modal>


                        {/* Modal Toast for successful update */}
                        <Modal show={false} onHide={() => { }} centered backdrop="static">
                            <div className="text-center p-3 p-md-4">
                                <div style={{ backgroundColor: "#d4edda", color: "#155724", padding: "10px", borderRadius: "8px 8px 0 0" }}>
                                    <h5 className="fw-bold">SUCCESS</h5>
                                </div>
                                <div className="mt-3">
                                    <img 
                                        src={modal} 
                                        alt="Success" 
                                        style={{ 
                                            maxWidth: "100%", 
                                            height: "auto", 
                                            maxHeight: "200px" 
                                        }} 
                                    />
                                </div>
                                <div className="mt-3">
                                    <h6 className="fw-bold">Location updated successfully!</h6>
                                </div>
                            </div>
                        </Modal>
                    </div>
                </div>
            </CModalBody>
        </CModal>
    </>
    );
};

export default EditLocation;
